import { createSelector } from 'reselect';
import { QUESTS } from '../../Helpers/quests';

const getQuestsSlice = state => state.quests;

export const getActiveQuestId = createSelector(
    getQuestsSlice,
    q => q?.active || null,
);

export const getActiveQuest = createSelector(
    [getActiveQuestId, getQuestsSlice],
    (id, q) => {
        if (!id || !q) return null;
        const def = QUESTS[id];
        const progress = q.progress?.[id];
        if (!def || !progress) return null;
        const step = def.steps[progress.currentStep];
        return {
            id,
            title: def.title,
            currentStep: progress.currentStep,
            stepDescription: step?.description || '',
            counters: progress.counters || {},
        };
    },
);
